<template>
  <div class="leftMenuPage float-left" id="left_bar">
    <el-menu
      :default-active="activeMenu"
      style="border-radius: 8px"
      :unique-opened="false"
      text-color="#666666"
      active-text-color="#1F1F1F"
      class="el-menu-vertical-demo left_menu"
    >
      <template v-for="(item, index) in nowChildMenuList">
        <el-menu-item
          v-if="!item.children && item.isShow"
          :key="'item'+index"
          :index="fistMenuPath + '' + item.path"
          @click="handleMenuClick(item.path, item)"
        >
          <template slot="title">
            <div class="flexc-cen-x">
              {{item.name}}
            </div>
          </template>
        </el-menu-item>
        <el-submenu
          class="left-nav-color"
          v-if="item.children && item.isShow"
          :index="fistMenuPath + '' + item.path"
          :key="item.path"
        >
          <template slot="title">
            <div class="flexc-cen-x">
              {{item.name}}
            </div>
          </template>
          <el-menu-item-group class="child-menu">
            <el-menu-item
              style="padding-left: 30px"
              :index="fistMenuPath + '' + item.path + childItem.path"
              v-for="(childItem, childIndex) in item.children"
              :key="'child' + childIndex"
              @click="handleMenuClick(item.path + '' + childItem.path, item)"
              >{{ childItem.name }}</el-menu-item
            >
          </el-menu-item-group>
        </el-submenu>
      </template>
    </el-menu>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isMemberSystemInfo: false,
    };
  },
  computed: {
    nowChildMenuList() {
      let actIndex = this.$store.getters.fistActIndex;
      console.log("actIndex", actIndex);
      let childMenuList = this.$store.getters.childMenuList;
      console.log("childMenuList", childMenuList);
      let childMenu =  childMenuList[actIndex];
      console.log("childMenu", childMenu);
      this.isMemberSystemInfo = this.$store.state.isMemberSystemInfo;
      if(childMenu != undefined && childMenu.length && childMenu.length > 0) {
        childMenu.forEach((item) => {
        item.isShow = true;
        if (item.name == "新建会员体系" || item.name == "会员通指南") {
          if (this.isMemberSystemInfo) {
            item.isShow = false;
          } else {
            item.isShow = true;
          }
        }
        if (item.name == "会员信息管理" || item.name == "忠诚度管理") {
          if (this.isMemberSystemInfo) {
            item.isShow = true;
          } else {
            item.isShow = false;
          }
        }
      });
      
      }
      return childMenu;
    },
    activeMenu() {
      return this.$store.getters.activeMenu;
    },
    fistMenuPath() {
      let actIndex = this.$store.getters.fistActIndex;
      let fistMenuList = this.$store.getters.fistMenuList;
      return fistMenuList.length > 0
        ? fistMenuList[actIndex].path
        : "";
    },
  },
  watch: {
    activeMenu: {
      handler(newValue, oldValue) {
        // console.log("newValue", newValue);
      },
      deep: true,
      immediate: true,
    },
    nowChildMenuList: {
      handler(newValue, oldValue) {
        // console.log("newValue", newValue);
      },
      deep: true,
      immediate: true,
    }
  },
  props: {
    paths: {
      type: Array,
      default: () => [],
    },
  },
  mounted() {
  },
  methods: {
    iconUrl(name) {
      let iconObj = [
        {
          name: "会员体系列表",
          icon: require("@/assets/new-image/leftmenu/list.svg"),
        },
        {
          name: "新建会员体系",
          icon: require("@/assets/new-image/leftmenu/add.svg"),
        },
        {
          name: "会员信息管理",
          icon: require("@/assets/new-image/leftmenu/info.svg"),
        },
        {
          name: "忠诚度管理",
          icon: require("@/assets/new-image/leftmenu/zhong.svg"),
        },
        {
          name: "会员通指南",
          icon: require("@/assets/new-image/leftmenu/zhinan.svg"),
        },
      ];
      let icon = "";
      iconObj.forEach((item) => {
        if (item.name == name) {
          icon = item.icon;
          return;
        }
      });
      return icon;
    },
    handleMenuClick(path, item) {
      if (item.menuType == "M" && item.children == null) {
        this.$router.push("/nodata");
        this.$message.warning("无对应权限，可联系您的专属业务帮您解决问题哦~");
        return;
      }
      let actIndex = this.$store.state.fistActIndex;
      let nowPath = this.$store.state.fistMenuList[actIndex].path + path;
      this.$router.push(nowPath);
    },
  },
};
</script>

<style scoped lang="scss">
@import "./index.scss";
</style>
<style lang="scss">
  /deep/.el-submenu .el-menu-item {
    max-width: 180px !important;
  }
</style>
